export const mustBeLessThan =
  (max: number, message?: string, allowEmpty: boolean = true) =>
  (value: string) => {
    if (allowEmpty && !value) return undefined;
    return value.length <= max
      ? undefined
      : message || `Veuillez saisir au plus ${max} caractères.`;
  };
